// #5119 R1 — the single Ask Helix affordance outside `/ask`.
//
// Every surface that used to mount the legacy answer drawer now renders exactly
// one plain link here. No query params (#5119 R1); grounding hand-off is #5161. Until
// that lands, `/ask` starts from zero context — the per-site loss is disclosed in the
// PR body under A-R1.
//
// `@/components/ui/button` has no `asChild`/Slot (button.tsx:51-74 forwards to a native
// `<button>`), so "looks like a Button, is actually a link" can only be built by styling
// a `next/link` with Button's class vocabulary. `@/components/ui/link-button` already is
// exactly that, imports only `next/link` + `@/lib/cn`, and is not on either fence's
// forbidden list (eslint.config.mjs no-restricted-imports; ask.boundary.spec.ts
// FORBIDDEN_SPECIFIER_FRAGMENTS) — so this file wraps it rather than duplicating it.

import { LinkButton } from '@/components/ui/link-button';

export type AskHelixLinkProps = {
  /** Per-site spacing only. The visual family is fixed so all 16 sites read the same. */
  className?: string;
  /**
   * Defaults to `ask-helix-link`. Call sites that replaced a drawer trigger pass the
   * trigger's original testid so existing suites keep resolving the same affordance.
   */
  testId?: string;
};

export function AskHelixLink({ className, testId = 'ask-helix-link' }: AskHelixLinkProps) {
  return (
    <LinkButton
      href="/ask"
      variant="outline"
      size="sm"
      className={className}
      data-testid={testId}
    >
      Ask Helix
    </LinkButton>
  );
}

export default AskHelixLink;
